/**
 * ErrorHandlerService is a class that handles error signals and manages modal dialogs for error display.
 * It listens for error signals, opens modals based on log levels, and handles modal interactions.
 */
class ErrorHandlerService {
    /**
     * Constructs an instance of ErrorHandlerService.
     * @param {Object} $signals - The signals service for event handling.
     * @param {Object} $timeout - The AngularJS timeout service.
     * @param {Object} $rootScope - The AngularJS root scope.
     * @param {Object} $uibModal - The AngularUI Bootstrap modal service.
     * @param {Object} $bridges - The bridges service for runtime operations.
     */
    constructor($signals, $timeout, $rootScope, $uibModal, $bridges) {
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$bridges = $bridges;

        this.$rootScope.errorHandlerSignals = {};

        this.activeFunctions = {
            info: false,
            warn: false,
            error: true,
            debug: false,
            fatal: true
        };
        this.stopApp = {
            info: false,
            warn: false,
            error: false,
            debug: false,
            fatal: true
        };

        this.modalInstance = null;

        this.onErrorSignal = this.onErrorSignal.bind(this);
        this.openModal = this.openModal.bind(this);

        $signals.on('ErrorHandler', this.onErrorSignal);

        $rootScope.$on("$destroy", () => {
            $signals.remove('ErrorHandler', this.onErrorSignal);
        });
    }

    /**
     * Handles the error signal by checking the log level and opening a modal if necessary.
     * @param {string} logLevel - The log level of the error.
     * @param {string} logline - The error message.
     */
    onErrorSignal(logLevel, logline) {
        logLevel = logLevel.toLowerCase();
        if (this.activeFunctions[logLevel] === true && this.$rootScope.stopApp !== true) {
            this.openModal(logLevel, logline);
        }
    }

    /**
     * Opens a modal dialog to display the error.
     * @param {string} logLevel - The log level of the error.
     * @param {string} logline - The error message.
     */
    openModal(logLevel, logline) {
        this.$rootScope.errorHandlerStopApp = this.stopApp[logLevel];
        this.$rootScope.errorHandlerLogMessage = logline;
        this.$rootScope.errorHandlerLogLevel = logLevel.toUpperCase();

        this.modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/modules/errorhandler/errorhandler.html',
            backdrop: this.$rootScope.errorHandlerStopApp ? 'static' : true
        });
    }

    /**
     * Quits the application when an error modal is closed with a quit action.
     */
    onErrorModalQuit() {
        this.$bridges.runtime().quit(false);
    }

    /**
     * Closes the error modal when the OK button is clicked.
     */
    onErrorModalOK() {
        this.modalInstance.close();
    }
}

export default ErrorHandlerService;